/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React from 'react';
import {
    object,
} from 'prop-types';
import loadable from '@loadable/component';
import mbpLogger from '@module-logger/mbp';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Link } from 'react-router-dom';
import styles from './ExtraTall.module.css';

import ResponsiveWrapper from '../../../../../SubComponents/ResponsiveWrapper';
import universalHandleClick from '../../../../../UniversalHandleClick';
import ConditionalWrapper from '../../../../ConditionalWrapper';

const LinkListBanner = loadable(() => import(/* webpackChunkName: "LinkListBanner" */ '../../../../../SubComponents/LinkListBanner/LinkListBanner'));
const MessageStandard = loadable(() => import(/* webpackChunkName: "MessageStandard" */ '../../../../../SubComponents/Message/MessageStandard'));

const ExtraTallBanner = ({ data, salesforceResponse }) =>     {
    useStyles(styles);
    if (!Object.keys(data)?.length) {
        return mbpLogger.logError({
            appName: process.env.npm_package_name,
            component: 'Banner/1up/Standard/ExtraTall/ExtraTall.js',
            message: 'No data available to render component',
        });
    }
    const isBackground =  data?.message?.has_background;
    const linkListPosition = data?.link_list?.[0]?.link_list?.position || 'row';
    const backgrounds = {
        desktop: data.background_image?.desktop?.url,
        tablet: data.background_image.tablet?.url || data.background_image?.desktop?.url, // can add fallbacks easily this way
        mobile: data.background_image.mobile?.url || data.background_image.tablet?.url || data.background_image?.desktop?.url,
    };
    const device = (matches) => Object.keys(matches).find((key) => matches[key]); // returns device type string

    const renderLinkList = (matches, deviceArray) => {
        if (data.has_link_list && deviceArray.includes(device(matches))) return <LinkListBanner data={data.link_list[0]} />;
        return <></>;
    };
    const handleClick = universalHandleClick(salesforceResponse);

    const imageQuality = '?auto=webp';
    const getMessageText = (value) => (typeof value === 'string' ? value.trim() : '');
    const hasMessage = (message) => {
        const heading = getMessageText(message?.heading) || getMessageText(message?.content?.heading?.text);
        const subHeading = getMessageText(message?.sub_heading) || getMessageText(message?.content?.sub_heading?.text);
        return Boolean((heading && subHeading) || (heading || subHeading));
    };

    const renderBanner = (matches) => (
        <>
            <div style={{ backgroundImage: `url(${backgrounds[device(matches)]}${imageQuality})`, flexDirection: linkListPosition }} className={`${styles.banner} ${data?.has_link_list ? styles.wrapperContainer : ''}`}>
                {Object.keys(data.message)?.length > 0 && (data?.link_list?.length > 0 && (isBackground || !isBackground)) && <div className={`${styles.messageBlock} ${isBackground ? styles.messageBg : ''}`}><MessageStandard data={data.message} /></div>}
                {!isBackground && !data?.link_list?.length && <div className={`${styles.messageBlock} ${isBackground ? styles.messageBg : ''}`}><MessageStandard data={data.message} /></div>}
                {(device(matches) === 'desktop' || device(matches) === 'tablet') && isBackground && !data?.link_list?.length && <div className={`${styles.messageBlock} ${isBackground ? styles.messageBg : ''}`}><MessageStandard data={data.message} /></div>}
                {renderLinkList(matches, ['desktop'])}
            </div>
            {device(matches) === 'mobile' && isBackground && !data?.link_list?.length && <div className={`${styles.messageBlock} ${isBackground ? styles.messageBg : ''}`}><MessageStandard data={data.message} /></div>}
            {renderLinkList(matches, ['tablet', 'mobile'])}
            {backgrounds[device(matches)] && (
                <picture>
                    <source srcSet={`${backgrounds[device(matches)]}${imageQuality}`} />
                    <img src={`${backgrounds[device(matches)]}${imageQuality}`} alt="background image" height="0" width="0" className={styles.lcpImage} loading="lazy" />
                </picture>
            )}
        </>
    );
    const bannerLink = data?.message?.cta?.[0]?.link?.href || false;
    const bannerLinkText = !!data?.message?.cta?.[0]?.link?.title;
    return (
        <ConditionalWrapper
            condition={!hasMessage(data?.message) && !bannerLinkText && bannerLink}
            wrapper={(children) => <Link to={bannerLink} aria-label={data.background_image?.desktop?.title}>{children}</Link>}
        >
            <div data-testid="extraTallBanner" className={`${bannerLink && bannerLinkText ? styles.bannerContainer : ''} ${isBackground && data?.has_link_list ? styles.container : ''}`} role="presentation" onClick={() => handleClick(data?.message?.cta?.[0])}>
                <ResponsiveWrapper renderer={renderBanner} />
            </div>
        </ConditionalWrapper>
    );
};
ExtraTallBanner.propTypes = {
    data: object.isRequired,
    salesforceResponse: object,
};
ExtraTallBanner.defaultProps = {
    salesforceResponse: {},
};
export default ExtraTallBanner;
